module.exports = __webpack_public_path__ + "resources/icon_32_refresh.9e8cac5414863997.png";


//////////////////
// WEBPACK FOOTER
// ../src/ui/icon/img/icon_32_refresh.png
// module id = 453
// module chunks = 0 1 2 3 4